import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import {
    formataMesAnoTextoComBarra,
} from '../../../business-components/Date/Date'

import {
    formataValor,
} from '../../../business-components/Formata/Formata'

import {
    GridContainerReport,
    GridItem2,
    GridItem4,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import {
    formataReportTituloColuna,
    formataReportTituloLinha,
    formataReportTextoMesAnoInicialFinal,
    formataReportValor,
} from '../../../business-components/Formata/Formata'

import PlanejamentoEspecializacaoPeriodoSabaticoChart from '../estudo-chart/PlanejamentoEspecializacaoPeriodoSabaticoChart'



const EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo = ( { values, estudo, report } ) => {

    return (
        <>
            <GridItem12
                align='left'
                className={report ? 'ml-2 mt-10' : 'ml-2 mt-7'}
            >
                <h6>
                    <span
                        dangerouslySetInnerHTML={{ __html: 
                            MESSAGE().gerarLancamentosPlanejamentoEspecializacaoPeriodoSabatico
                                .replaceAll("$descricao$",
                                    values.planejamentoEspecializacaoPeriodoSabatico.descricaoEspecializacaoPeriodoSabatico)
                                        .replace("$1$", formataValor(values.planejamentoEspecializacaoPeriodoSabatico
                                            .valorEspecializacaoPeriodoSabatico, 2))
                                                .replace("$2$", formataValor(values.planejamentoEspecializacaoPeriodoSabatico
                                                    .valorPresenteInicioEspecializacaoPeriodoSabatico, 2))
                                                        .replace("$3$", values.planejamentoEspecializacaoPeriodoSabatico
                                                            .mesesAcumulacao)
                                                                .replace("$4$", formataMesAnoTextoComBarra(
                                                                    values.planejamentoEspecializacaoPeriodoSabatico
                                                                        .mesAnoFinalAcumulacao))
                                                                            .replace("$5$", formataMesAnoTextoComBarra(
                                                                                values.planejamentoEspecializacaoPeriodoSabatico
                                                                                    .mesAnoInicialEspecializacaoPeriodoSabatico))
                        }}
                    />
                </h6>
            </GridItem12>

            <GridItem12
                className={report ? 'mt-15 mb-10' : 'mt-10'}
            >
                <CardGridDivBody>
                    <GridContainerReport>
                        <GridItem6/>
                        <GridItem2>
                            {
                                formataReportTituloColuna(LABEL.receitaMensal)
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportTituloColuna(LABEL.diaDia)
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportTituloColuna(LABEL.saldo)
                            }
                        </GridItem2>
                    </GridContainerReport>

                    <GridContainerReport
                        className="mt-4"
                    >
                        <GridItem2>
                            {
                                formataReportTituloLinha(LABEL.antes)
                            }
                        </GridItem2>
                        <GridItem4
                            align='center'
                        >
                            {
                                formataReportTextoMesAnoInicialFinal(values.planejamentoEspecializacaoPeriodoSabatico.mesAnoInicialAcumulacao,
                                    values.planejamentoEspecializacaoPeriodoSabatico.mesAnoFinalAcumulacao)
                            }
                        </GridItem4>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalAntesEspecializacaoPeriodoSabatico )
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorDiaDiaAntesEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalAntesEspecializacaoPeriodoSabatico - 
                                    values.valorDiaDiaAntesEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                    </GridContainerReport>

                    <GridContainerReport
                        className="mt-4"
                    >
                        <GridItem2>
                            {
                                formataReportTituloLinha(LABEL.durante)
                            }
                        </GridItem2>
                        <GridItem4
                            align='center'
                        >
                            {
                                formataReportTextoMesAnoInicialFinal(
                                    values.planejamentoEspecializacaoPeriodoSabatico.mesAnoInicialEspecializacaoPeriodoSabatico,
                                        values.planejamentoEspecializacaoPeriodoSabatico.mesAnoFinalEspecializacaoPeriodoSabatico)
                            }
                        </GridItem4>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalDuranteEspecializacaoPeriodoSabatico )
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorDiaDiaDuranteEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalDuranteEspecializacaoPeriodoSabatico - 
                                    values.valorDiaDiaDuranteEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                    </GridContainerReport>

                    <GridContainerReport
                        className="mt-4"
                    >
                        <GridItem2>
                            {
                                formataReportTituloLinha(LABEL.depois)
                            }
                        </GridItem2>
                        <GridItem4
                            align='center'
                        >
                            {
                                formataReportTextoMesAnoInicialFinal(
                                    values.planejamentoEspecializacaoPeriodoSabatico.mesAnoInicialDepoisEspecializacaoPeriodoSabatico,
                                        values.planejamentoEspecializacaoPeriodoSabatico.mesAnoFinalDepoisEspecializacaoPeriodoSabatico)
                            }
                        </GridItem4>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalDepoisEspecializacaoPeriodoSabatico )
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorDiaDiaDepoisEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                        <GridItem2>
                            {
                                formataReportValor(values.valorReceitaMensalDepoisEspecializacaoPeriodoSabatico - 
                                    values.valorDiaDiaDepoisEspecializacaoPeriodoSabatico)
                            }
                        </GridItem2>
                    </GridContainerReport>
                </CardGridDivBody>
            </GridItem12>

            <GridItem12>
                <PlanejamentoEspecializacaoPeriodoSabaticoChart
                    values={values}
                    estudo={estudo}
                    report={true}
                />
            </GridItem12>
        </>
    )
}

export default EstudoFormPlanejamentoEspecializacaoPeriodoSabaticoResumo